import React from "react";
import "./input-label.css";
import { Input } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Tooltip } from "@progress/kendo-react-tooltip";

import PropTypes from "prop-types";

const InputLabel = ({
  title,
  inputValue,
  setValue,
  onChangeText,
  tooltipText,
  maxLength,
  position,
  ...others
}) => {
  return (
    <div className="inputLabelPure-input-style">
      <div className="inputLabelPure-title">
        <Label
          title="hue"
          className="inputLabelPure-label"
        >
          {title}
        </Label>
        {tooltipText && (
          <Tooltip openDelay={100} position={position} anchorElement="target">
            <div
              style={{
                textAlign: "center",
              }}
            >
              <i class="tooltip-icon k-icon k-i-information" 
                title={tooltipText}
              />
            </div>
          </Tooltip>
        )}
      </div>
      <Input
        className="inputLabelPure-input"
        value={inputValue}
        onChange={(event) => {
          setValue(event.value);
          onChangeText(event);
        }}
        {...others}
        style={{ width: "100% !important" }}
        maxLength={maxLength ? maxLength : 150}
      />
    </div>
  );
};

export default InputLabel;

InputLabel.propTypes = {
  title: PropTypes.string,
  inputValue: PropTypes.string,
  disabled: PropTypes.bool,
  setValue: PropTypes.func,
  onChangeText: PropTypes.func,
};

InputLabel.defaultProps = {
  title: "",
  inputValue: "",
  disabled: false,
  onChangeText: () => {},
  setValue: () => {},
};
